import React, { useState, useEffect } from 'react';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../Contexts/AuthContext';

const AddItemTemporary = ({ addItem }) => {
  const { token } = useAuth();
  const [formData, setFormData] = useState({
    meal_type: '',
    source: '',
    reason: '',
    food_type: '',
    food_description: '',
    is_edible: '',
    empty_weight: '',
    total_weight: '',
    employee_name: '',
    shift: '',
    waste_date: '',
    // day: '',
  });
  const [popupVisible, setPopupVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(''); // Clear previous errors

    try {
      // ✅ Prepare API Request Data
      const requestData = {
        ...formData,
        is_edible: formData.is_edible.toLowerCase() === 'صالح', // Convert "صالح" to `true` and otherwise `false`
      };

      // ✅ Send Data to API
      const response = await api.post('/employee/collected-data', requestData, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 && response.data.status) {
        addItem(response.data.data); // ✅ Add new item to parent state
        setPopupVisible(true); // ✅ Show success message
        setFormData({
          meal_type: '',
          food_type: '',
          food_description: '',
          source: '',
          reason: '',
          is_edible: '',
          empty_weight: '',
          total_weight: '',
          employee_name: '',
          shift: '',
          waste_date: '',
          // day: '',
        }); 
      } else {
        setErrorMessage('فشل في إضافة البيانات.');
      }
    } catch (error) {
      console.error('Error submitting collected data:', error);
      setErrorMessage('حدث خطأ أثناء إرسال البيانات. حاول مرة أخرى.');
    }
  };

  const closePopup = () => {
    setPopupVisible(false); // Hide success popup
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl text-right font-semibold text-gray-700 mb-6">إضافة عنصر</h1>

       {/* 🛑 Error Message */}
       {errorMessage && <p className="text-red-500 text-center">{errorMessage}</p>}
       
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Row 1 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
            <label htmlFor="food_type" className="block text-sm text-right font-medium text-gray-700 mb-2">
              نوع الغذاء
            </label>
            <input
              type="text"
              id="food_type"
              name="food_type"
              value={formData.food_type}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل نوع الغذاء"
              required
            />
          </div>
          <div>
            <label htmlFor="reason" className="block text-sm text-right font-medium text-gray-700 mb-2">
              السبب
            </label>
            <input
              type="text"
              id="reason"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل السبب"
              required
            />
          </div>
          <div>
            <label htmlFor="source" className="block text-sm text-right font-medium text-gray-700 mb-2">
              المصدر
            </label>
            <input
              type="text"
              id="source"
              name="source"
              value={formData.source}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل المصدر"
              required
            />
          </div>
          <div>
            <label htmlFor="meal_type" className="block text-sm text-right font-medium text-gray-700 mb-2">
              نوع الوجبة
            </label>
            <input
              type="text"
              id="meal_type"
              name="meal_type"
              value={formData.meal_type}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل نوع الوجبة"
              required
            />
          </div>
          
          
          
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
            <label htmlFor="total_weight" className="block text-sm text-right font-medium text-gray-700 mb-2">
              اجمالي الوزن
            </label>
            <input
              type="number"
              id="total_weight"
              name="total_weight"
              value={formData.total_weight}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل اجمالي الوزن"
              required
            />
          </div>
          <div>
            <label htmlFor="empty_weight" className="block text-sm text-right font-medium text-gray-700 mb-2">
              الوزن الفارغ
            </label>
            <input
              type="number"
              id="empty_weight"
              name="empty_weight"
              value={formData.empty_weight}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل الوزن الفارغ"
              required
            />
          </div>
          <div>
            <label htmlFor="is_edible" className="block text-sm text-right font-medium text-gray-700 mb-2">
              صالح/غير صالح
            </label>
            <select
              id="is_edible"
              name="is_edible"
              value={formData.is_edible}
              onChange={handleChange}
              className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
      ${formData.is_edible === '' ? 'text-gray-400' : 'text-black'}`}
              required
            >
              <option value="">اختر</option>
              <option value="صالح">صالح</option>
              <option value="غير صالح">غير صالح</option>
            </select>
          </div>
          <div>
            <label htmlFor="food_description" className="block text-sm text-right font-medium text-gray-700 mb-2">
              وصف الغذاء
            </label>
            <input
              type="text"
              id="food_description"
              name="food_description"
              value={formData.food_description}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل وصف الغذاء"
              required
            />
          </div>
         
          
      
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
            <label htmlFor="waste_date" className="block text-sm text-right font-medium text-gray-700 mb-2">
              التاريخ
            </label>
            <input
              type="date"
              id="waste_date"
              name="waste_date"
              value={formData.waste_date}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border text-gray-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              required
            />
          </div>
           <div>
            <label htmlFor="day" className="block text-sm text-right font-medium text-gray-700 mb-2">
              اليوم
            </label>
            <input
              type="text"
              id="day"
              name="day"
              value={formData.day}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل اليوم"
              required
            />
          </div>
          
          <div>
  <label htmlFor="shift" className="block text-sm text-right font-medium text-gray-700 mb-2">
    الوردية
  </label>
  <select
    id="shift"
    name="shift"
    value={formData.shift}
    onChange={handleChange}
    className={`w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D] bg-white 
    ${formData.shift === '' ? 'text-gray-400' : 'text-black'}`}
    required
  >
    <option value="">اختر الوردية</option>
    <option value="A">A</option>
    <option value="B">B</option>
    <option value="C">C</option>
  </select>
</div>
          <div>
            <label htmlFor="employee_name" className="block text-sm text-right font-medium text-gray-700 mb-2">
              اسم الموظف
            </label>
            <input
              type="text"
              id="employee_name"
              name="employee_name"
              value={formData.employee_name}
              onChange={handleChange}
              className="w-full px-4 py-2 text-right border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#F4A68D]"
              placeholder="أدخل اسم الموظف"
              required
            />
          </div>
         
         
         
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className=" bg-[#DD5B35] text-white py-2 px-4 rounded-lg hover:bg-[#F4A68D] hover:text-black"
        >
          إضافة عنصر
        </button>
      </form>
      {popupVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <h2 className="text-lg font-semibold mb-4">تمت إضافة العنصر بنجاح</h2>
            <button
              onClick={closePopup}
              className="bg-[#DD5B35] text-white py-2 px-4 rounded-lg hover:bg-[#F4A68D] hover:text-black focus:outline-none"
            >
              إغلاق
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddItemTemporary;
